import { Badge, BadgeLevel, BadgeShape, BadgeSize } from '../badge';

/**
 * Small rectangular "EDITED" metadata badge used to indicate a user has
 * overridden a value. Currently consumed beside the "Class" label on the Asset
 * Details Page when an asset's `classEdited` flag is true (see SPM-2897).
 */
function EditedBadge() {
  return (
    <Badge level={BadgeLevel.Default} size={BadgeSize.Xs} shape={BadgeShape.Box} className="px-2">
      EDITED
    </Badge>
  );
}

export { EditedBadge };
